import {LinePlotDisplayRowFnType} from '../types';
import {LinePlotTemplateSettings} from '../workspaceTemplatesQueries';
import {
  getGroupAggDisplayRow,
  getGroupSettingDisplayRow,
} from './groupingDisplayValues';
import {getMaxRunsDisplayRow} from './maxRunsDisplayValues';
import {getSmoothingWeightDisplayRow} from './smoothingDisplayValues';
import {
  getXAxisDisplayRow,
  getXAxisFormatDisplayRow,
  getXAxisMaxDisplayRow,
  getXAxisMinDisplayRow,
  getXLogScaleDisplayRow,
} from './xAxisDisplayValues';
import {
  getYAxisMaxDisplayRow,
  getYAxisMinDisplayRow,
  getYLogScaleDisplayRow,
} from './yAxisDisplayValues';

/**
 * Display functions for line plot template fields.
 * Note: smoothingType is handled separately via useSmoothingTypeDisplayRow hook
 * because it needs access to the backend smoothing feature flag.
 */
export const LINE_PLOT_TEMPLATE_DISPLAY_FNS: Partial<
  Record<keyof LinePlotTemplateSettings, LinePlotDisplayRowFnType>
> = {
  groupAgg: getGroupAggDisplayRow,
  maxRuns: getMaxRunsDisplayRow,
  smoothingWeight: getSmoothingWeightDisplayRow,
  useRunsTableGroupingInPanels: getGroupSettingDisplayRow,
  xAxis: getXAxisDisplayRow,
  xLogScale: getXLogScaleDisplayRow,
  xAxisMin: getXAxisMinDisplayRow,
  xAxisMax: getXAxisMaxDisplayRow,
  xAxisFormat: getXAxisFormatDisplayRow,
  yLogScale: getYLogScaleDisplayRow,
  yAxisMin: getYAxisMinDisplayRow,
  yAxisMax: getYAxisMaxDisplayRow,
};
